import { apiRequest } from './index';

/**
 * Fetch weekly statistics data
 *
 * @param {number} year Year
 * @param {number} week Week number
 * @returns {Promise<Object>} Statistics data
 */
export const fetchStatistics = async (year, week) => {
  try {
    const response = await apiRequest({
      url: `/api/statistics.php?method=get_weekly_statistics&year=${year}&week=${week}`,
      method: 'GET'
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching statistics:', error);
    throw error;
  }
};

/**
 * Fetch statistics data for multiple weeks
 *
 * @param {number} year Starting year
 * @param {number} week Starting week number
 * @param {number} numWeeks Number of weeks to fetch (default: 4)
 * @returns {Promise<Object>} Multi-week statistics data
 */
export const fetchMultiWeekStatistics = async (year, week, numWeeks = 4) => {
  try {
    const response = await apiRequest({
      url: `/api/statistics.php?method=get_multi_week_statistics&year=${year}&week=${week}&num_weeks=${numWeeks}`,
      method: 'GET'
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching multi-week statistics:', error);
    throw error;
  }
};

/**
 * Recalculate statistics for a specific week
 *
 * @param {number} year Year
 * @param {number} week Week number
 * @returns {Promise<Object>} Result data
 */
export const recalculateWeekStatistics = async (year, week) => {
  try {
    const response = await apiRequest({
      url: '/api/statistics.php?method=recalculate_statistics',
      method: 'POST',
      data: { year, week, skip_sync:true }
    });

    return response.data;
  } catch (error) {
    console.error('Error recalculating week statistics:', error);
    throw error;
  }
};

/**
 * Fetch available weeks for statistics
 *
 * @returns {Promise<Array>} List of available weeks
 */
export const fetchAvailableWeeks = async () => {
  try {
    const response = await apiRequest({
      url: '/api/statistics.php?method=get_available_weeks',
      method: 'GET'
    });

    return response.data?.weeks || [];
  } catch (error) {
    console.error('Error fetching available weeks:', error);
    throw error;
  }
};

/**
 * Get current week data
 *
 * @returns {Object} Current year and week number
 */
export const getCurrentWeek = () => {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 1);
  const diff = now - start;
  const oneWeek = 604800000; // milliseconds in a week
  const weekNumber = Math.floor(diff / oneWeek) + 1;

  return {
    year: now.getFullYear(),
    week: weekNumber
  };
};
